import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex-grow bg-neutral-100" }
const _hoisted_2 = { class: "container mx-auto max-w-6xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl mt-8 mb-6 ml-6" }, "Contact", -1)
const _hoisted_4 = { class: "flex flex-col gap-8 bg-white shadow p-6 pb-10 mb-20 rounded lg:flex-row" }
const _hoisted_5 = { class: "lg:w-1/2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mx-auto mb-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "mx-auto rounded-full",
    src: "img/ruurtjan-150.jpg",
    alt: "Ruurtjan from NsLookup"
  })
], -1)
const _hoisted_7 = { class: "prose prose-lg" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:hello@nslookup.io" }, "hello@nslookup.io", -1)
const _hoisted_9 = { class: "lg:w-1/2" }
const _hoisted_10 = {
  class: "grid gap-y-6",
  action: "/forms/contact",
  method: "POST"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div><label for=\"name\" class=\"block text-sm font-medium text-gray-900\">Name</label><div class=\"mt-1\"><input type=\"text\" name=\"name\" id=\"name\" autocomplete=\"off\" class=\"block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500\"></div></div><div><label for=\"email\" class=\"block text-sm font-medium text-gray-900\">Email</label><div class=\"mt-1\"><input id=\"email\" name=\"email\" type=\"email\" autocomplete=\"email\" class=\"block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500\"></div></div><div><div class=\"flex justify-between\"><label for=\"message\" class=\"block text-sm font-medium text-gray-900\">Message</label></div><div class=\"mt-1\"><textarea id=\"message\" name=\"message\" rows=\"4\" class=\"block w-full rounded-md border border-gray-300 py-3 px-4 text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500\" aria-describedby=\"message-max\"></textarea></div></div>", 3)
const _hoisted_14 = { class: "flex flex-col justify-between items-end gap-6 sm:flex-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "mt-2 h-fit inline-flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-500 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
}, "Send", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:hello@nslookup.io",
  class: "underline font-semibold"
}, "hello@nslookup.io", -1)

import MetaTags from '@/components/MetaTags.vue';
import TurnstileCaptcha from '@/components/TurnstileCaptcha.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import Alert from '@/components/micro/AlertComponent.vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Contact — NsLookup.io",
        description: "NsLookup.io is made by Ruurtjan Pul, an independent developer. You can contact him using this form or via email.",
        url: "https://www.nslookup.io/contact-us/"
      })
    ])),
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (['#', ''].includes(_unref(route).hash))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", _hoisted_7, [
                    _createTextVNode(" Ruurtjan here, maker of "),
                    _createVNode(_component_router_link, {
                      to: "/",
                      title: "nslookup"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("nslookup")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(". Have feedback or a question? Send me an email at "),
                    _hoisted_8,
                    _createTextVNode(" or fill out the form, and I'll be in touch as soon as possible. ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("form", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(TurnstileCaptcha, {
                        sitekey: "0x4AAAAAAAFYkSLIi59M27dr",
                        id: "contact"
                      }),
                      _hoisted_15
                    ])
                  ])
                ])
              ], 64))
            : (_unref(route).hash === '#message-sent')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createTextVNode(" Thank you for your message!"),
                  _hoisted_17,
                  _hoisted_18,
                  _createTextVNode("I'll be in touch as soon as possible. ")
                ]))
              : (_openBlock(), _createBlock(Alert, {
                  key: 2,
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Your message could not be sent."),
                    _hoisted_19,
                    _hoisted_20,
                    _createTextVNode("Please email me at "),
                    _hoisted_21,
                    _createTextVNode(" instead. ")
                  ]),
                  _: 1
                }))
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})